import React from "react";
import { read, store } from "Helpers/LocalStorage";
import PaymentService from "Services/http/endpoints/payment/PaymentService";
import StatusHandler from "Helpers/StatusHandler";
import MuiButton from "Components/MuiButton/MuiButton";
import showNotify from "Helpers/Notify";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";
import { Grid, Paper } from "@material-ui/core";

export default function Package({ chargeCredit }) {
  const { t } = useTranslation();

  const onClickChargeCredit = async (item) => {
    const payId = item.Id;
    try {
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: payId,
      };
      const response = await PaymentService.postChargeCredit(data);
      let err = StatusHandler(response);
      const pay = response.data.Value;
      if (!err.isFail) {
        if (pay.IsError === false) {
          store("orderId", pay.Describ);
          window.open(pay.Link, "_self");
        } else if (pay.IsError === true) {
          showNotify({ text: pay.Describ, customClass: "error" });
        }
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };

  return (
    <Paper>
      <div container className="wallet-package">
        {!chargeCredit ? (
          <span>{t("Nothing_found")}</span>
        ) : (
          chargeCredit.map((item) => {
            return (
              <div className="wallet-package-items">
                <div className="wallet-package-head">
                  <p>{item.Describ}</p>
                  {item.Title !== "" && (
                    <div className="spc">
                      <Icons.PatchCheckFill size={27} />
                    </div>
                  )}
                </div>
                <div className="wallet-package-body">
                  <div>
                    <span>{t("payableAmount")} : </span>
                    <p>
                      <strong>{item.Price.toLocaleString()}</strong>
                      <span className="me-1">{t("moneyUnit")}</span>
                    </p>
                  </div>
                  <div>
                    <span>{t("receivedAmount")} : </span>
                    <p>
                      <strong>{item.PriceCredit.toLocaleString()}</strong>
                      <span className="me-1">{t("moneyUnit")}</span>
                    </p>
                  </div>
                  <MuiButton
                    color="primary"
                    title={t("payment")}
                    innerIcon={<Icons.CreditCard2BackFill />}
                    className="w-100"
                    onClick={() => onClickChargeCredit(item)}
                  />
                </div>
              </div>
            );
          })
        )}
      </div>
    </Paper>
  );
}
